import { Component, OnInit, inject } from '@angular/core';

import { Router, RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { RoleRequestCartComponent } from '../role-request-cart/role-request-cart.component';
import { MultiOrgFilterTAComponent } from '../multi-org-filter-ta/multi-org-filter-ta.component';
import { RoleRequestSuccessComponent } from '../role-request-success/role-request-success.component';
import { AlertComponent } from 'src/app/modules/shared/components/alert/alert.component';
import { SpinnerComponent } from 'src/app/modules/shared/components/spinner/spinner.component';
import { RoleRequestService } from 'src/app/modules/user-profile/services/role-request.service';
import { UserRole, RoleRequestPayload, CartRole, Organization } from 'src/app/modules/user-profile/models/role-request.models';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-role-request-remove-role',
    imports: [
    CommonModule,
    RoleRequestCartComponent,
    RouterModule,
    MultiOrgFilterTAComponent,
    RoleRequestSuccessComponent,
    FormsModule,
    AlertComponent,
    SpinnerComponent
],
    templateUrl: './role-request-remove-role.component.html',
    styleUrl: './role-request-remove-role.component.css'
})
export class RoleRequestRemoveRoleComponent implements OnInit {
  private roleRequestService = inject(RoleRequestService);
  private spinner = inject(NgxSpinnerService);

  rolesOnCart: CartRole[] = [];
  selectedRoles: any[] = [];
  userRoles: any[] = [];
  isRequestSuccess = false;
  showErrorMessage: string;
  initialSelRole: UserRole = null;

  ngOnInit(): void {
  }

  private loadUserRoles(): void {
    this.spinner.show('request-remove-role');
    this.roleRequestService.getRolesByPersonKey(this.roleRequestService.getLoggedInPersonKey(), true)
    .subscribe(data => {
      this.userRoles = data.personOrgRole.personOrgRoleList.map(x => {
        x.roleName = x.role.name;
        x.roleKey = x.role.key;
        return x;
      }).filter(x => x.organization.key === this.roleRequestService.multiOrgFilters.selectedOrganization?.orgKey);
      
      this.userRoles.forEach(role => {
        const roleResponsibility = data.roleResponsibilities.find(x => x.roleKey === role.roleKey);
        if (roleResponsibility) {
          role.roleResponsibilities = roleResponsibility.roleResponsibilities;
          role.roleResponsibilities?.forEach((x: any) => {
            x.roleResponsibility = x.roleResponsibility.split('.').filter(x => x).map(x => x + '.');
            x.roleResponsibility = [...new Set(x.roleResponsibility)];
            if( x.roleResponsibility.length > 1) {
              x.roleResponsibility = x.roleResponsibility.filter(x => !x.includes('No Information available'));
            }
          })
        }
      });
      this.userRoles.sort((a, b) => a.roleName?.localeCompare(b.roleName));
      this.spinner.hide('request-remove-role');
    }, err => {
      this.showError(err.error.resultMessage);
    }, () => this.spinner.hide('request-remove-role'));
  }

  isSelected(roleSel: UserRole): boolean {
    return !!this.selectedRoles.find(role => roleSel.roleKey === role.roleKey);
  }

  onRoleCheckBoxChange(event: any, roleSelected: UserRole): void {
    if (event.target.checked) {
      if(!this.initialSelRole || !this.initialSelRole?.['reason']) {
        this.initialSelRole = roleSelected;
      } else if(!roleSelected['reason']) {
        roleSelected['reason'] = this.initialSelRole?.['reason'];
      }
      this.selectedRoles.push(roleSelected);
    } else {
      this.selectedRoles = this.selectedRoles.filter(role => role.roleKey !== roleSelected.roleKey);
    }
  }

  addRolesToCart(): void {
    this.showErrorMessage = '';
    if(this.selectedRoles.some(role => !role.reason?.trim())) {
      this.showError("Please provide a reason to remove the selected roles.");
      return;
    }

    this.selectedRoles.forEach(role => {
      if (!this.rolesOnCart.find(x => x.roleKey === role.roleKey)) {
        this.rolesOnCart.push({ ...role, applicationRoleName: role.roleName });
        this.userRoles = this.userRoles.filter(urole => urole.roleKey !== role.roleKey);
      }
    });
  }

  removeRole(role: UserRole): void {
    this.rolesOnCart = this.rolesOnCart.filter(x => x.roleKey !== role.roleKey);
    this.selectedRoles = this.selectedRoles.filter(x => x.roleKey !== role.roleKey);
    this.userRoles.push({ ...role });
    this.userRoles.sort((a, b) => a.roleName?.localeCompare(b.roleName));
  }

  submitRoleRequest(): void {
    const payload = this.createPayload();
    this.spinner.show('request-remove-role');
    this.roleRequestService.roleRequestPost(payload).subscribe(
      () => {
        this.showErrorMessage = '';
        this.handleRequestSuccess()
      },
      (err) => {
        this.spinner.hide('request-remove-role');
        this.showError(err.error.resultMessage);
      }
    );
  }

  private createPayload(): RoleRequestPayload[] {
    const { selectedOrganization } = this.roleRequestService.multiOrgFilters;
    const today = new Date().toISOString().split('T')[0];
    return this.rolesOnCart.map(role => ({
      personKey: +this.roleRequestService.getLoggedInPersonKey(),
      roleKey: role.roleKey,
      usageTypeKey: 0,
      assignGroupKey: +this.roleRequestService.multiOrgFilters.selectedRoleGroup.roleAssignGroupKey,
      orgKey: selectedOrganization?.orgKey,
      roleRequestText: role.reason || ' ',
      roleRequestTypeKey: 2,
      effectiveDate: today
    }));
  }

  private handleRequestSuccess(): void {
    this.isRequestSuccess = true;
    this.spinner.hide('request-remove-role');
  }

  onOrgChange(event: Organization): void {
    this.loadUserRoles();
  }

  onRoleGroupChange(event: any): void {
    this.clearAll();
  }

  clearAll(): void {
    this.selectedRoles = [];
    this.userRoles = [];
  }

  showError(message: string): void {
    this.showErrorMessage = message;
    window.scrollTo(0, 0);
  }

}
